import React, { useState } from "react";
import WebData from "../../../../Helpers/WebData";
import ImageItem from "../../EngageImages/Type1/ImageItem";
import ReactMarkdown from "react-markdown";
import "./VirtualAdoption.style.css";
import "../../EngageImages/Type1/ImageItem.css";

const VirtualAdoption = ({ setTab }) => {
  const [current, setCurrent] = useState(0);
  function showNextCard() {
    if (current < WebData.vAdoptionCows.names.length - 1) {
      setCurrent(current + 1);
    }
  }

  function showPrevCard() {
    if (current > 0) {
      setCurrent(current - 1);
    }
  }

  const paragraph =
    "Our family is big, and growing! Bhagini was born with us. She has grown big but hasn't forgotten her playfulness. Ramesvar is an orphan of the dairy industry. He was found brought to our care with a broken leg. Chitti is our third generation vechur breed with he first Nandi. Bhairav is radiant and sturdy - quite a change since he was brought in as a child, badly bitten by stray dogs. We make every effort to accomodate as many as we can. But we could really use some help. Our virtual adoption program was designed for busy people or those without large open spaces. You can could choose from a variety of options ranging from life-time adoption to event-based adoption such as medicare during birthing period or during old age. We would really like you to visit us when you can and spend stress-buster time with your pet. We will keep you updated through regular sharing of videos and photos. Check the photos then click below. Act now!";
  return (
    <>
      <section id="virtualAdoptionBanner">
        <div className="row v-adoption-row">
          <div className="col-12 text-center mt-10px mt-md-4 order-first order-md-last">
            <a
              className="engageBtn"
              id="v-pills-donate-tab"
              data-toggle="pill"
              href="#v-pills-donate"
              role="tab"
              aria-controls="v-pills-donate"
              aria-selected="false"
              onClick={() => {
                setTab("donate");
              }}
            >
              Adopt {WebData.vAdoptionCows.names[current].name} Now
            </a>
          </div>
          <div className="col-md-5 shadow-col image-view">
            <div className="cards-wrapper">
              <span
                id="right-arrow"
                className={`arrow right fa fa-chevron-right ${
                  current === WebData.vAdoptionCows.names.length - 1
                    ? "fa-disabled"
                    : ""
                }`}
                onClick={() => showNextCard()}
              ></span>
              <span
                id="left-arrow"
                className={`arrow left fa fa-chevron-left ${
                  current === 0 ? "fa-disabled" : ""
                }`}
                onClick={() => showPrevCard()}
              ></span>
              <ImageItem imageIndex={current} locationFrom="vAdoption" />
            </div>
          </div>
          <div className="v-adoption col-md-7 d-flex shadow-col content-view justify-desc order-last order-md-first scrollbar-hide">
            <ReactMarkdown>{paragraph}</ReactMarkdown>
          </div>
        </div>
      </section>
    </>
  );
};

export default VirtualAdoption;
